interface AwsCognitoConfig {
  region: string | undefined;
  userPoolId: string | undefined;
  userPoolClientId: string | undefined;
  userPoolEndpoint: string | undefined;
  authenticationFlowType: 'CUSTOM_AUTH';
}

interface AwsAuthConfig {
  Cognito: AwsCognitoConfig;
}

interface AwsExports {
  Auth: AwsAuthConfig;
}

const awsExports: AwsExports = {
  Auth: {
    Cognito: {
      region: import.meta.env.VUE_APP_AWS_REGION,
      userPoolId: import.meta.env.VUE_APP_USER_POOL_ID,
      userPoolClientId: import.meta.env.VUE_APP_USER_POOL_CLIENT_ID,
      // The CloudFront proxy that injects the app client secret. Must include the
      // scheme: Amplify parses it with `new URL()`.
      userPoolEndpoint: import.meta.env.VUE_APP_USER_POOL_ENDPOINT,
      authenticationFlowType: 'CUSTOM_AUTH',
    },
  },
};

export default awsExports;
